
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-google-fill',
      title: 'Google Ads',
      description: 'Maximize your reach with targeted Google Ads campaigns that drive qualified traffic and conversions.',
      features: ['Search Campaigns', 'Display Advertising', 'Shopping Ads', 'Performance Max']
    },
    {
      icon: 'ri-facebook-fill',
      title: 'Social Media Advertising',
      description: 'Engage your audience across Facebook, Instagram, LinkedIn, Twitter, and TikTok with compelling ad creatives.',
      features: ['Facebook & Instagram Ads', 'LinkedIn Campaigns', 'Twitter Promotion', 'TikTok Advertising']
    },
    {
      icon: 'ri-global-line',
      title: 'Native Advertising',
      description: 'Reach premium audiences through Outbrain, Taboola, and other native advertising platforms.',
      features: ['Outbrain Campaigns', 'Taboola Promotion', 'Content Amplification', 'Native Placements']
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Analytics & Optimization',
      description: 'Data-driven insights and continuous optimization to maximize your advertising ROI.',
      features: ['Performance Tracking', 'A/B Testing', 'Conversion Optimization', 'ROI Analysis']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Our Services</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We offer comprehensive digital marketing solutions to help your business reach new heights
          </p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-orange-100 rounded-lg">
                  <i className={`${service.icon} text-2xl text-orange-500`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4">{service.description}</p>
                  <ul className="space-y-2">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-orange-500 mr-2"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
